import React from 'react';

const DrawerContext = React.createContext<{
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}>(undefined);

export function DrawerProvider({ children }: any) {
  const [drawerOpen, setDrawerOpen] = React.useState<boolean>(false);
  const value = { drawerOpen, setDrawerOpen };
  return (
    <DrawerContext.Provider value={value}>{children}</DrawerContext.Provider>
  );
}

export function useDrawer() {
  const context = React.useContext(DrawerContext);
  if (context === undefined) {
    throw new Error('useDrawer must be used within a DrawerProvider');
  }
  return context;
}
